<div class="entity-config-page land-court-page container-fluid px-0 py-0 py-lg-1">
  <div class="entity-config-shell d-flex flex-column gap-2 mx-auto px-4 py-3">
    <div class="land-court-sticky-header">
      <div class="ms-2 col">
        <h4 class="fw-bold lh-sm mb-3">My Case Load</h4>
        <h3 class="entity-page-subtitle text-dark mt-1 mb-0">{{ summary_text }}</h3>
      </div>

      <section class="land-court-panel land-court-toolbar-panel rounded-4 border-0 p-2">
        <div class="row g-2 align-items-stretch">
          <div class="col-12 col-lg">
            <div class="input-group">
              <span class="input-group-text land-court-search-addon rounded-start-4">
                <i class="bi bi-search text-secondary"></i>
              </span>
              <input
                v-model.trim="search_query"
                type="text"
                class="form-control  border-start-0 rounded-end-4 py-2"
                placeholder="Search by case number, citation, party, or attorney..."
              >
            </div>
          </div>

          <div class="col-12 col-lg-auto">
            <button
              type="button"
              class="btn land-court-submit-btn rounded px-3 d-inline-flex align-items-center gap-2 mt-1"
              @click="toggle_filters"
            >
              <i class="bi bi-sliders"></i>
              <span>Filter</span>
            </button>
          </div>
        </div>

        <section v-if="show_filters" class="land-court-filter-panel rounded-4 border-0 p-3 p-lg-4 mb-3 mt-4">
          <div class="row g-3">
            <div class="col-12 col-lg-6">
              <label class="form-label land-court-filter-label">Status</label>
              <select v-model="filter_form.status" class="form-select land-court-modal-input rounded-4">
                <option value="">Any status</option>
                <option v-for="option in filter_options.statuses" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>

            <div class="col-12 col-lg-6">
              <label class="form-label land-court-filter-label">Farm</label>
              <select v-model="filter_form.farm" class="form-select land-court-modal-input rounded-4">
                <option value="">Any farm</option>
                <option v-for="option in filter_options.farms" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>

            <div class="col-12 col-lg-6">
              <label class="form-label land-court-filter-label">Province</label>
              <select v-model="filter_form.province" class="form-select land-court-modal-input rounded-4">
                <option value="">Any province</option>
                <option v-for="option in filter_options.provinces" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>

            <div class="col-12 col-lg-6">
              <label class="form-label land-court-filter-label">Legal representation</label>
              <select v-model="filter_form.legal_representation" class="form-select land-court-modal-input rounded-4">
                <option value="">Any firm</option>
                <option v-for="option in filter_options.legal_representations" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>

            <div class="col-12 col-lg-6">
              <label class="form-label land-court-filter-label">Claim type</label>
              <select v-model="filter_form.claim_type" class="form-select land-court-modal-input rounded-4">
                <option value="">Any claim type</option>
                <option v-for="option in filter_options.claim_types" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>

            <div class="col-12 col-lg-6">
              <label class="form-label land-court-filter-label">Town/District</label>
              <input
                id="land_court_town_district_filter"
                v-model.trim="filter_form.town_district"
                type="text"
                class="form-control land-court-modal-input rounded-4"
                placeholder="Search town or district"
                autocomplete="off"
                @input="apply_filters"
              >
            </div>

            <div class="col-12 col-lg-6">
              <label class="form-label land-court-filter-label">Municipality</label>
              <input
                v-model.trim="filter_form.municipality"
                type="text"
                class="form-control land-court-modal-input rounded-4"
                placeholder="Municipality"
                @input="apply_filters"
              >
            </div>
          </div>

          <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-3 mt-3 pt-3 border-top">
            <div class="small text-secondary">{{ active_filter_summary }}</div>

            <button
              type="button"
              class="btn land-court-submit-btn rounded px-3"
              @click="clear_filters"
            >
              <i class="bi bi-x-square me-2"></i>
              Clear all filters
            </button>
          </div>
        </section>
      </section>
    </div>

    <section class="land-court-panel rounded-4 border-0 p-2">
      <div v-if="loading_caseload && !filtered_case_groups.length" class="land-court-empty-state rounded-4 px-4 py-5 text-center">
        <div class="fw-semibold mb-1">Loading your Case Load...</div>
        <div class="small text-secondary">Fetching live case records.</div>
      </div>

      <div v-if="!loading_caseload && !filtered_case_groups.length" class="land-court-empty-state rounded-4 px-4 py-5 text-center">
        <div class="fw-semibold mb-1">No cases found</div>
        <div class="small text-secondary">
          {{ total_cases ? 'Try a different search term.' : 'Load your first case to start building this caseload.' }}
        </div>
      </div>

      <div v-if="filtered_case_groups.length" class="d-flex flex-column gap-3">
        <article
          v-for="group in paginated_case_groups"
          :key="group.id"
          class="entity-row-card land-court-group-card bg-white rounded-4 border-0 shadow-sm overflow-hidden"
        >
          <button
            type="button"
            class="land-court-group-toggle w-100 px-3 py-3 border-0 text-start shadow-sm"
            @click="toggle_group(group.id)"
            :aria-expanded="is_group_open(group.id)"
          >
            <div class="row g-2 align-items-center">
              <div class="col-12 col-lg">
                <div class="d-flex align-items-center gap-3">
                  <div class="entity-section-icon rounded-3 d-inline-flex align-items-center justify-content-center">
                    <i class="bi bi-grid-3x3-gap-fill"></i>
                  </div>
                  <div class="min-w-0">
                    <div class="fw-bold land-court-group-title">{{ group.name }}</div>
                    <div class="small land-court-group-meta">
                      {{ group.location }} - {{ group.cases.length }} case<span v-if="group.cases.length !== 1">s</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-auto d-flex justify-content-lg-end">
                <span class="land-court-chevron d-inline-flex align-items-center justify-content-center">
                  <i class="bi fs-3" :class="is_group_open(group.id) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                </span>
              </div>
            </div>
          </button>

          <div
            v-if="is_group_open(group.id)"
            v-for="case_item in group.cases"
            :key="case_item.record_id || case_item.application_id"
            class="px-3 py-3 border-bottom land-court-case-row"
          >
            <div class="row g-3 align-items-center">
              <div class="col-12 col-md-3 col-xl-2">
                <div class="fw-semibold land-court-case-number">{{ case_item.case_number }}</div>
              </div>

              <div class="col-12 col-md-9 col-xl-6">
                <div class="fw-medium land-court-case-name">{{ case_item.case_name }}</div>
              </div>

              <div class="col-12 col-sm-6 col-xl-2">
                <span
                  class="badge rounded-pill px-3 py-2 fw-semibold land-court-status-badge"
                  :class="status_badge_class(case_item.status_variant)"
                >
                  {{ case_item.status }}
                </span>
              </div>

              <div class="col-6 col-sm-3 col-xl-1">
                <div class="small land-court-case-files text-nowrap">{{ case_item.filings }} filings</div>
              </div>

              <div class="col-6 col-sm-3 col-xl-1 d-flex justify-content-end">
                <button
                  type="button"
                  class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
                  :disabled="!case_item.application_id"
                  @click="open_case_details(case_item)"
                >
                  <i class="bi bi-eye"></i>
                  <span>View</span>
                </button>
              </div>
            </div>
          </div>
        </article>

        <section class="land-court-pagination-panel rounded-4 px-3 px-lg-4 py-3">
          <div class="d-flex flex-column flex-xl-row justify-content-between align-items-start align-items-xl-center gap-3">
            <div class="land-court-pagination-copy">
              <div class="land-court-pagination-title">{{ batch_entries_summary }}</div>
              <div class="land-court-pagination-subtitle">{{ source_page_summary }}</div>
            </div>

            <div class="land-court-pagination-actions d-flex align-items-center gap-2 flex-wrap">
              <button
                type="button"
                class="btn land-court-page-btn rounded-4 px-3"
                :disabled="current_page === 1"
                @click="go_to_page(current_page - 1)"
              >
                Previous
              </button>

              <button
                v-for="page_number in visible_page_numbers"
                :key="page_number"
                type="button"
                class="btn land-court-page-btn land-court-page-number rounded-4"
                :class="{ 'land-court-page-btn-active': page_number === current_page }"
                @click="go_to_page(page_number)"
              >
                {{ page_number }}
              </button>

              <button
                type="button"
                class="btn land-court-page-btn rounded-4 px-3"
                :disabled="current_page === total_group_pages"
                @click="go_to_page(current_page + 1)"
              >
                Next
              </button>
            </div>
          </div>

          <div
            v-if="source_total_pages > 1"
            class="d-flex justify-content-end align-items-center gap-2 mt-3 pt-3 border-top"
          >
            <button
              type="button"
              class="btn land-court-page-btn rounded-4 px-3"
              :disabled="source_page === 1"
              @click="go_to_source_page(source_page - 1)"
            >
              Previous
            </button>

            <button
              type="button"
              class="btn land-court-page-btn rounded-4 px-3"
              :disabled="source_page === source_total_pages"
              @click="go_to_source_page(source_page + 1)"
            >
              Next
            </button>
          </div>
        </section>
      </div>
    </section>
  </div>

  <div
    v-if="show_load_case_modal"
    class="land-court-modal-backdrop"
    @click.self="close_load_case_modal"
  >
    <div class="land-court-modal-card rounded-4 shadow-lg">
      <LoadCaseDynamicForm
        :case-context="case_context"
        :entity-type-options="entity_type_options"
        :selected-entity-type-id="selected_entity_type_id"
        :data-selection-options="load_case_data_selection_options"
        :submit-error="submit_case_error"
        :submitting="create_case_running"
        @cancel="close_load_case_modal"
        @entity-type-change="on_load_case_entity_type_change"
        @submit="submit_load_case"
      />
    </div>
  </div>
</div>
